const getLocale = function getLocation() {
    return document.body.dataset.domain;
};

export default getLocale;
